import { createContext } from 'react';

const AllContext = createContext();

export const allProvider = AllContext.Provider
export const allConsumer = AllContext.Consumer

export default AllContext